export const modal = {
    successTitle: 'Congratulations!',
    failedTitle: 'Failed!',
    successApprove: 'Concession successfully approved.',
    failedApprove: 'Concession approved failed! Please try again.',

    success: 'Document successfully uploaded.',
    removeTitle: 'Remove File!',
    remove: 'Document successfully removed.',
    removeFailed: 'Document deleted failed! Please try again.',
    jobaccept: 'Job has been accepted.',
    jobdispute: 'Job has been disputed.',

    deleteTitle: 'Remove Product!',
    deleteItemSuccess: 'Product successfully removed.',
    deleteItemFailed: 'Product deleted failed! Please try again.',

    deleteTitleTransporter: 'Remove Transporter!',
    deleteItemSuccessTransporter: 'Transporter successfully removed.',
    deleteItemFailedTransporter: 'Transporter deleted failed! Please try again.',

    deleteTitleShip: 'Remove Ship!',
    deleteItemSuccessShip: 'Ship successfully removed.',
    deleteItemFailedShip: 'Ship deleted failed! Please try again.',

};